// © Microsoft Corporation. All rights reserved.

import { AppError } from "@msnews/diagnostics";

/**
 * This is a global tracking object which is used to avoid
 * the need to have hard dependencies to a telemetry package.
 * Think of this as an interface which is overrided at runtime
 * by each app-type.
 */

interface TelemetryBase {
    trackAppErrorEvent(error: AppError): void;
    sendSinglePageViewBeacon(beaconId: string): void;
    trackPartialImpression(element?: any, viewType?: any, visibilityCheck?: boolean, mechanism?: string, topLevelContainerType?: string): void;
    trackEvent(element: HTMLElement,
               action?: string,
               behavior?: number,
               event?: any,
               destination?: any,
               headline?: string,
               module?: string,
               index?: string,
               campaign?: string,
               contentAction?: number): void;
}

export const TelemetryBase: TelemetryBase = {
    trackAppErrorEvent: (): void => undefined,
    sendSinglePageViewBeacon: (): void => undefined,
    trackPartialImpression: (): void => undefined,
    trackEvent: (): void => undefined
};